export default "__VITE_ASSET__ec0ce7cb__"